import BasicButton from "@/components/core/buttons/BasicButton";
import { Signatory } from "@/type/core/dashboard/dashboard.types";
import { Right } from "@/type/core/offices/offices.types";
import { InvitationMode } from "@/type/core/transaction/transaction.types";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

interface TransactionISignButtonProps {
  nextSignatory?: Signatory;
  userEmail?: string;
  userSerialNumber?: string;
  officeRights: Right[];
  className?: string;
  transactionInvitationMode?: InvitationMode;
}

const TransactionISignButton: FunctionComponent<
  TransactionISignButtonProps
> = ({
  nextSignatory,
  userEmail,
  userSerialNumber,
  officeRights,
  className,
  transactionInvitationMode,
}) => {
  const { t } = useTranslation();

  const directSignature = () => {
    // A les droits de signature
    if (officeRights.includes("SIGNATURE_COLLECTE_SIGNER")) {
      // La transaction est en mode d'invitation parallèle et soit il n'y a pas de nextSignatory défini soit le nextSignatory est l'utilisateur et n'a pas signé
      if (
        transactionInvitationMode &&
        transactionInvitationMode === "parallel" &&
        (!nextSignatory ||
          (nextSignatory &&
            nextSignatory.email === userEmail &&
            nextSignatory.status !== "signed"))
      ) {
        return true;
      }
      // La transaction est séquentielle et le prochain signataire est l'utilisateur
      else if (
        nextSignatory &&
        nextSignatory.email === userEmail &&
        !!userSerialNumber
      ) {
        return true;
      }
    }
    // Aucun des cas plus haut n'est respecté
    return false;
  };

  return (
    directSignature() && (
      <BasicButton
        variant="primary"
        text={t("home.dashboard.table.buttons.ISign")}
        onClick={() => window.open(nextSignatory?.url, "_blank")}
        className={`py-11 px-30 font-extra-small ${className}`}
      />
    )
  );
};

export default TransactionISignButton;
